export default __webpack_public_path__ + "static/media/Baobab_Coin.13ef5fc0.svg";